/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */
// router navagation constant
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
//common constants
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SENDING_REQUEST = 'SENDING_REQUEST';
export const GET_ERROR = 'GET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const REQUEST_ERROR = 'REQUEST_ERROR';

/*** Auth ***/
export const LOGOUT = 'LOGOUT';
export const SESSION_EXPIRATION = 'SESSION_EXPIRATION';
export const EXPIRATION_CHECKED = 'EXPIRATION_CHECKED';
export const REFRESH_REQUEST = 'REFRESH_REQUEST';
export const PING_REQUEST = 'PING_REQUEST';
export const SET_CSRFTOKEN = 'SET_CSRFTOKEN';
export const GET_CSRFTOKEN = 'GET_CSRFTOKEN';
export const SET_STAGE = 'SET_STAGE';
export const REFRESH_CHECK_STOP = 'REFRESH_CHECK_STOP';
export const SET_MFA_EXPIRATION = 'SET_MFA_EXPIRATION';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const LOADING = 'LOADING';

/*** Modals ***/
export const TIMEOUT_MODAL_STATUS = 'TIMEOUT_MODAL_STATUS';
export const CHANGE_THEME = 'CHANGE_THEME';
export const SET_SNACKBAR_STATUS = 'SET_SNACKBAR_STATUS';
export const FETCH_QUEUES_NAVIGATION = 'FETCH_QUEUES_NAVIGATION';
export const SEARCH_APPLICATION_ID = 'SEARCH_APPLICATION_ID';
export const QUICK_SEARCH_APP_ID = 'QUICK_SEARCH_APP_ID';
export const FETCH_LAST_TEN = 'FETCH_LAST_TEN';
export const SET_MOBILE_STATUS = 'SET_MOBILE_STATUS';
export const SET_LAST_TEN = 'SET_LAST_TEN';

/* NAVIGATION */
export const SET_NAV_LIST = 'SET_NAV_LIST';

/*** ROUTE SAGA FLOW ACtions ***/

export const A_ROUTE_FLOW_DONE = "A_ROUTE_FLOW_DONE";
export const B_ROUTE_FLOW_DONE = "B_ROUTE_FLOW_DONE";